/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

function prepareHostedEnvironmentDetails() {
  const location = window.location,
    hostName = location.hostname,
    protocol = location.protocol,
    port = location.port;

  if (hostName === 'localhost' || hostName === '127.0.0.1' || hostName === '172.31.36.237') {
    /* For local development */
    environment.host = protocol + '//' + hostName + ':' + port + '/8084';
  } else {
    /*  - For hosted env with ip address
     *   - port is defaulted to 80 incase not available
     */
    environment.host = protocol + '//' + hostName + ':' + (port || '') + '/api';

    /* Here we can handle the masked URLs as well
     *  like http://dev-mlm.com can be mapped to any ip
     */
  }
}

prepareHostedEnvironmentDetails();

platformBrowserDynamic().bootstrapModule(AppModule);
